export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13214.78e185da.jpg";